import { render, staticRenderFns } from "./ModalGenerateRtb30.vue?vue&type=template&id=f8bf9c6a&scoped=true"
import script from "./ModalGenerateRtb30.vue?vue&type=script&lang=js"
export * from "./ModalGenerateRtb30.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf9c6a",
  null
  
)

export default component.exports